import Vue from "vue";
import Vuex from "vuex";

import farms from "@/store/modules/farms";
import chat from "./modules/diagnostics";

import chatSocket from "./plugins/ros";

import RosService from "@/services/RosService.js";

Vue.use(Vuex);
let loggedIn = localStorage.getItem("loggedIn");
export default new Vuex.Store({
  state: {
    loggedIn: loggedIn === "true",
    selectedVideo: null,
    selectedTomato: null,
    confirmationRequired: null,
    tomatoesPerBox: null,
    sprayRate: 1000,
    shouldPathBeSprayed: false,
  },
  mutations: {
    LOGIN(state, value) {
      state.loggedIn = value;
      localStorage.setItem("loggedIn", value);
    },
    SWITCH_VIDEO(state, value) {
      state.selectedVideo = value;
    },
    TOMATO_SETTINGS(state, value) {
      state.selectedTomato = value;
    },
    CONFIRMATION_REQUIRED(state, value) {
      state.confirmationRequired = value;
    },
    TOMATOES_PER_BOX(state, value) {
      state.tomatoesPerBox = value;
    },
    SPRAY_RATE(state, value) {
      state.sprayRate = value;
    },
    SHOULD_PATH_BE_SPRAYED(state, value) {
      state.shouldPathBeSprayed = value;
    },
  },
  actions: {
    switchVideo({ commit }, video) {
      commit("SWITCH_VIDEO", video);
    },
    selectedTomato({ commit, getters }, index) {
      commit("TOMATO_SETTINGS", index);
      RosService.updateSettings(getters.gatherSettings);
    },
    confirmationRequired({ commit, getters }, value) {
      commit("CONFIRMATION_REQUIRED", value);
      RosService.updateSettings(getters.gatherSettings);
    },
    tomatoesPerBox({ commit, getters }, value) {
      commit("TOMATOES_PER_BOX", value);
      RosService.updateSettings(getters.gatherSettings);
    },
    selectedTomatoInit({ commit, getters }, index, shouldUpdate) {
      commit("TOMATO_SETTINGS", index);
    },
    confirmationRequiredInit({ commit, getters }, value) {
      commit("CONFIRMATION_REQUIRED", value);
    },
    tomatoesPerBoxInit({ commit, getters }, value) {
      commit("TOMATOES_PER_BOX", value);
    },
    sprayRateAction({ commit, getters }, value) {
      commit("SPRAY_RATE", value);
      RosService.setSprayingRate(value);
    },
    shouldPathBeSprayedAction({ commit, getters }, value) {
      commit("SHOULD_PATH_BE_SPRAYED", value);
      RosService.setPathShouldBeSprayed(value);
    },
    login({ commit }, user) {
      // Implement login check
      if (user == null) {
        commit("LOGIN", false);
      } else {
        commit("LOGIN", true);
      }
    },
  },
  getters: {
    isLoggedIn: (state) => {
      state.loggedIn;
    },
    gatherSettings: (state) => {
      return {
        redness: state.selectedTomato,
        tomatoesPerBox: state.tomatoesPerBox,
        confirmationRequired: state.confirmationRequired,
      };
    },
  },
  modules: {
    chat,
    farms,
  },
  plugins: [chatSocket()],
});
